import script from "./AutorizationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AutorizationPage.vue?vue&type=script&setup=true&lang=js"

import "./AutorizationPage.vue?vue&type=style&index=0&id=7fe6f2f9&scoped=true&lang=scss"

import exportComponent from "/auth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fe6f2f9"]])

export default __exports__